import { ClickAwayListener, Box, Drawer, IconButton, Typography, useTheme } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { redirectToExternalUrl } from '../../utils/ATCOUtils';
import useResponsiveHelper from '../common/hooks/useResponsiveHelper';
import { Navigation } from './Header';
import { TypographyVariants } from '../../theme/TypographyVariants';

interface HeaderGlobalButtonProps {
    siteNavigationObject?: Navigation[];
    setGlobalButtonClicked: (globalButtonClicked: boolean) => void;
}

const useStyles = makeStyles((theme) => ({
    content: {
        display: 'flex',
        alignItems: 'center',
        height: '56px',
        '&:hover': {
            backgroundColor: theme.palette.neutral7,
        },
    },
    drawerPaper: {
        marginTop: '80px',
    },
}));

const HeaderGlobalButtons: React.FC<HeaderGlobalButtonProps> = (props: HeaderGlobalButtonProps) => {
    const theme = useTheme();
    const classes = useStyles();
    const { isMobileOrTablet } = useResponsiveHelper();
    const { siteNavigationObject, setGlobalButtonClicked } = props;

    return (
        <ClickAwayListener onClickAway={() => setGlobalButtonClicked(false)}>
            <Drawer
                classes={{
                    paper: classes.drawerPaper,
                }}
                variant="persistent"
                open={true}
                anchor="right"
                PaperProps={{
                    elevation: 6,
                    sx: { height: `${56 * (siteNavigationObject ? siteNavigationObject?.length : 0)}px`, width: isMobileOrTablet ? '100%' : '275px' },
                }}
            >
                {siteNavigationObject?.map((siteNavItem: Navigation) => {
                    return (
                        <Box key={siteNavItem.navText} className={classes.content}>
                            <IconButton
                                disableRipple={true}
                                aria-label={siteNavItem.altTextPath}
                                onClick={() => {
                                    redirectToExternalUrl(siteNavItem.path, true);
                                }}
                            >
                                <img src={siteNavItem.icon} alt={siteNavItem.altTextIcon} title={siteNavItem.altTextIcon} style={{ marginLeft: '10px', marginRight: '10px' }} />
                                <Typography variant={TypographyVariants.body1} color={theme.palette.neutral1} textTransform="capitalize">
                                    {siteNavItem.navText}
                                </Typography>
                            </IconButton>
                        </Box>
                    );
                })}
            </Drawer>
        </ClickAwayListener>
    );
};

export default HeaderGlobalButtons;
